export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="18" fill="#FF4F00" />
    <path d="M45 22.5A16 16 0 1 0 48 34H33" fill="none" stroke="#fff" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M41 12l9 9-12 3z" fill="#111" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5 text-left" data-testid="brand-logo">
    <LogoMark />
    <span className="leading-none">
      <span className={`block font-display text-2xl sm:text-[1.7rem] font-extrabold tracking-tight animate-blink-dot ${dark ? "text-white" : "text-ink"}`}>
        Go Trip<span className="text-go">.</span>
      </span>
      <span className={`hidden sm:block whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.18em] ${dark ? "text-zinc-400" : "text-zinc-600"}`}>
        Travels (OPC) Pvt Ltd
      </span>
    </span>
  </span>
);
